import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Inbox, ArrowRight } from 'lucide-react';

const items = [
  { id: 1, sev: 'danger', kind: '剧情平原', episode: 'EP08', sec: '45-90s', action: 'insert_scene' },
  { id: 2, sev: 'warning', kind: '冲突密度低', episode: 'EP05', sec: '128-180s', action: 'boost_hook' },
  { id: 3, sev: 'info', kind: '台词不自然', episode: 'EP03', sec: 'shot S07', action: 'rewrite_dialogue' },
];

export function TicketsPage() {
  return (
    <div className="p-6 lg:p-8">
      <header className="mb-6">
        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
          <Inbox className="h-6 w-6 text-warning" /> 工单收件箱
        </h1>
        <p className="mt-1 text-sm text-neutral-600">
          一键回传产生的结构化优化任务 · 跳转至 Writer / Director 一键应用
        </p>
      </header>

      <div className="space-y-3">
        {items.map((t) => (
          <Card key={t.id}>
            <CardContent className="flex items-center gap-3 py-4">
              <div
                className={
                  'h-12 w-1 rounded ' +
                  (t.sev === 'danger' ? 'bg-danger' : t.sev === 'warning' ? 'bg-warning' : 'bg-info')
                }
              />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <Badge variant={t.sev as 'danger' | 'warning' | 'info'}>{t.kind}</Badge>
                  <span className="text-sm font-medium">{t.episode}</span>
                  <span className="text-xs text-outline">{t.sec}</span>
                </div>
                <p className="mt-1 text-xs text-neutral-500">建议动作:{t.action}</p>
              </div>
              <Button variant="secondary" size="sm">
                查看 diff
              </Button>
              <Button variant="primary" size="sm">
                应用 <ArrowRight className="h-3.5 w-3.5" />
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
